import React from 'react';
import getFluidGatsbyImage from 'hooks/getFluidGatsbyImage';
import { WebsiteImage } from 'components/TitleDescription';
import { BlockQuoteContainer } from './styles';
import AddThisSocialSharing from 'components/AddThisSocialSharing';

const RichTextBlockQuote = ({ fields, ...otherProps }) => {
  const { quote, speaker } = fields || {};
  const quoteText = quote && quote['en-US'];
  const speakerContent = speaker && speaker['en-US'];

  const { url, contentType, details } =
    (speakerContent &&
      speakerContent.fields?.photo &&
      speakerContent.fields?.photo['en-US'].fields?.image['en-US'].fields?.file['en-US']) ||
    '';

  const firstName =
    (speakerContent &&
      speakerContent.fields?.firstName &&
      speakerContent.fields?.firstName['en-US']) ||
    '';
  const lastName =
    (speakerContent &&
      speakerContent.fields?.lastName &&
      speakerContent.fields?.lastName['en-US']) ||
    '';
  const jobTitle =
    (speakerContent &&
      speakerContent.fields?.jobTitle &&
      speakerContent.fields?.jobTitle['en-US']) ||
    '';
  const fluidsrc = {
    fluid: getFluidGatsbyImage({ file: { contentType, url, details } }, { toFormat: 'webp' }),
  };
  const formattedQuote = quoteText?.startsWith('“') ? quoteText.substring(1) : quoteText;

  return (
    <BlockQuoteContainer {...otherProps}>
      <div className="blog-block-quote--content">
        <p className="blog-block-quote--quote">{formattedQuote}</p>
        <div className="blog-block-quote--author-sharing">
          {speakerContent && (
            <div className="blog-block-quote--author">
              {fluidsrc && (
                <WebsiteImage
                  className="blog-block-quote--photo"
                  alt={`${firstName} ${lastName}`}
                  src={fluidsrc}
                />
              )}
              {(firstName || jobTitle) && (
                <div className="blog-block-quote--author-info">
                  {firstName && (
                    <p className="blog-block-quote--speaker-name">{`${firstName} ${lastName}`}</p>
                  )}
                  {jobTitle && <p className="blog-block-quote--speaker-title">{`${jobTitle}`}</p>}
                </div>
              )}
            </div>
          )}
          <AddThisSocialSharing placement="quote" shareText={quoteText} />
        </div>
      </div>
    </BlockQuoteContainer>
  );
};

export default RichTextBlockQuote;
